// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__tefzS","xs":"styles_xs__ZFgDn","dot":"styles_dot__q4vA0","sm":"styles_sm__xCzoD","md":"styles_md__Iyzro","lg":"styles_lg__JvoXO","xl":"styles_xl__l6ucS"};